/*
 * @Author: xuejian3721
 * @Date: 2024-09-14 17:20:41
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-09-20 17:11:38
 */
import store from '@/store'

// 设置自助服务
export function setSelfServiceMsgStyle() {
  const selfServiceObj = store.state.chat.selfServiceObj || {}
  const content = store.state.mobile ? mobileSelfServiceStyle(selfServiceObj) : pcSelfServiceStyle(selfServiceObj)
  return content
}

function mobileSelfServiceStyle({ cardTitle, dialogTabCardButtonList, orderNo }) {
  let html = ''
  dialogTabCardButtonList.forEach((item, index) => {
    html += `<div style="line-height: 30px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;"
        onclick="selfService('${item.jumpType},${item.needCheckStatus},${item.jumpUrl},${orderNo}')">
        <div style="display: inline-block;font-size: 13px;color: #111111;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.buttonTitle}</div>
        <img style="width:10px;height: 10px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
  })
  return `<div class="msg-self-service" style="min-width:272px;min-height:71px;box-sizing: border-box;display:flex;flex-direction: column;">
    <div style="width: 100%;height:55px;display:flex;align-items: center;border-radius: 25px 25px 0 0;background-size: cover;background-position: center;background-image: url(https://s.yyjzt.com/kf-web/20240918/17266492964595c4e.png);">
      <div style="padding:0 10px;font-size: 15px;color: #111111;">${cardTitle || '请问有什么可以帮您？'}</div></div>
    <div style="flex: 1;margin-top:-5px;padding: 8px 10px;background-color:#ffffff;border-radius: 5px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
    ${html}
    </div>
  </div>`
}

function pcSelfServiceStyle({ cardTitle, dialogTabCardButtonList, orderNo }) {
  let html = ''
  dialogTabCardButtonList.forEach((item, index) => {
    html += `<div style="line-height: 37px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;border-bottom: 1px solid #F6F8FA;padding: 0 8px;"
         onclick="selfPcService('${item.jumpType},${item.needCheckStatus},${item.jumpUrl},${orderNo}')">
        <div style="display: inline-block;font-size: 14px;color: #333333;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.buttonTitle}</div>
        <img style="width:16px;height: 16px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
  })
  return `<div class="msg-card-qa" style="min-width: 324px;box-sizing: border-box;display: flex;flex-direction: column;border-radius: 0 20px 20px 20px;background: linear-gradient( 180deg, #FBEEFB 0%, #FDEBE8 55%, #F6F6F6 99%);min-height:120px">
    <div style="font-size: 14px; font-weight: bold; color: #333333; height: 42px; line-height: 42px; margin: 0 12px; display: flex; align-items: flex-end;">
    ${cardTitle || '请问有什么可以帮您？'}
    </div>
    <div style="margin: 0 12px 12px;background-color: #fff;border-radius: 8px;">
    ${html}
    </div>
  </div>`
}

// 设置联系人工客服
export function setNoInvoiceStyle(tips) {
  const content = store.state.mobile ? mobileNoInvoiceStyle(tips) : pcInvoiceStyle(tips)
  return content
}

function mobileNoInvoiceStyle(tips) {
  return `<div class="msg-no-invoice" style="box-sizing: border-box;background-color: #fff;padding: 15px 10px;border-radius: 15px;">
      <div style="font-size: 13px;color: #111111;line-height: 20px;">
        ${tips || '不好意思，您的订单没有发票可以开，如有疑问可以咨询人工客服'}
      </div>
      <div style="width:167px;height:35px;line-height: 35px;font-size: 15px;color: #fff;background: linear-gradient( 270deg, #FA2E00 0%, #FF7200 100%);
        border-radius: 25px;margin: 10px 40px 0;text-align: center;" onclick="contactService()">联系人工客服</div>
  </div>`
}

function pcInvoiceStyle(tips) {
  return `<div style="width: 324px; min-height: 100px; padding: 12px; box-sizing: border-box; margin-top: 8px; background: #F6F6F6;border-radius: 20px 20px 20px 20px;">
<div class="msg-no-invoice" style="box-sizing: border-box;background-color: #fff;padding: 8px;border-radius: 15px;">
      <div style="font-size: 13px;color: #111111;line-height: 20px;">
        ${tips || '不好意思，您的订单没有发票可以开，如有疑问可以咨询人工客服'}
      </div>
      <div
      style="width:100%;
      height:32px;
      line-height: 32px;
      font-size: 14px;
      color: #fff;
      margin-top: 8px;
      cursor: pointer;
      background: linear-gradient( 180deg, #FF772E 0%, #FF4710 100%);
      border-radius: 4px 4px 4px 4px;
      text-align: center;" onclick="contactService()">联系人工客服</div>
  </div>

</div>`
}

export function processUrl(url) {
  // 使用正则表达式匹配 param= 后面的内容
  const paramMatch = url.match(/param=([^&]*)/)
  if (paramMatch && paramMatch[1]) {
    // 对提取到的 param 部分进行 decodeURIComponent 解码
    const decodedParam = decodeURIComponent(paramMatch[1])
    // 将解码后的 param 部分替换到原始 URL 中
    const newUrl = url.replace(paramMatch[1], decodedParam)
    return newUrl
  } else {
    return url
  }
}
